import { shallowEqual, useSelector } from 'react-redux';
import { selectErrors as selectMoveInVerifyErrors } from 'state/move-in-date/move-in-date-slice';
import { useMeterType } from 'hooks/useMeterType';
import { useSupplyStatus } from 'hooks/useSupplyStatus';
import { isUneligibleMoveInError } from 'components/direct-sales/quote/utils';
import { useMoveInDataConsistency } from './useMoveInDataConsistency';

export const hasIneligibleError = (errors) => {
  return errors?.some(isUneligibleMoveInError);
};

export const useIsMoveInEligible = () => {
  const moveInVerifyErrors = useSelector(
    selectMoveInVerifyErrors,
    shallowEqual
  );
  const { isMixedNepSap } = useSupplyStatus();
  const isMoveInDataConsistent = useMoveInDataConsistency();
  const { hasAnyPrepayMeter } = useMeterType();

  return (
    !hasAnyPrepayMeter &&
    !isMixedNepSap &&
    !hasIneligibleError(moveInVerifyErrors) &&
    isMoveInDataConsistent
  );
};
